import { SavingsCalculatorProps } from './savings-calculator';

export const NoInterestRates = (props: SavingsCalculatorProps) => {
    if (props.interestRates?.length) {
        return null;
    }

    return <div className="r-bg-red-500 r-p-8 r-text-center r-font-bold r-text-white">Please configure the interest rates in the CMS!</div>;
};
